﻿function CreateGuid() {
  function _p8(s?: boolean) {
    var p = (Math.random().toString(16) + '000000000').substr(2, 8);
    return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
  }
  return _p8() + _p8(true) + _p8(true) + _p8();
}

function AddOptionRow(div: string, name: string) {
  var c = $('.' + div);

  var guid = CreateGuid();

  c.append(
    `<div class='col-sm-4'><input type='text' class='form-control' value='' name='${name}[${guid}].key' id='${name}[${guid}].key' /></div>`
  );
  c.append(
    `<div class='col-sm-8'><input type='text' class='form-control' value='' name='${name}[${guid}].value' id='${name}[${guid}].value' /></div>`
  );
}

globalThis.CreateGuid = CreateGuid;
globalThis.AddOptionRow = AddOptionRow;
